import React from "react";
import { Field } from "formik";
import MaskedInput from "react-text-mask";

const mask = [
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/
];
const maskValidation = /^([0-9]{14})$/;

const validate = (value: string) => {
  let errorMessage;
  if (!maskValidation.test(value)) {
    errorMessage = "CNPJ inválido";
  }
  return errorMessage;
};

interface Props {
  name: string;
  required: boolean;
  disabled?: boolean;
}

const InputCNPJ: React.FC<Props> = ({ name, required, disabled }) => (
  <Field
    name={name}
    validate={validate}
    render={({ field, form: { setFieldValue } }: any) => (
      <MaskedInput
        {...field}
        className="form-control form-control-sm"
        disabled={disabled}
        required={required}
        mask={mask}
        onChange={event => {
          let { value } = event.target;
          value = value.replace(/[.]+/g, "");
          value = value.replace("-", "");
          value = value.replace("/", "");
          setFieldValue(name, value);
        }}
      />
    )}
  />
);

export default InputCNPJ;
